import { IntegrationsMarketplaceGridAvailableView } from '../view/IntegrationsMarketplaceGridAvailableView';
import { templateIntegrationsMarketplaceGridAvailable } from '../view/template';
import { IntegrationsMarketplaceGridAvailableRepository } from '../repository/IntegrationsMarketplaceGridAvailableRepository';
import {
  BaseWebComponentController,
} from '../../../framework/BaseWebComponentController';
import { IntegrationsMarketplaceGridAvailableWebComponent } from '..';
import {
  CustomTemplateListRequest,
  GetItemsResponse
} from "../../../ui/gzCustomTemplateList/types";

export class IntegrationsMarketplaceGridAvailableController extends BaseWebComponentController {
  public component: IntegrationsMarketplaceGridAvailableWebComponent;
  public dataRepository: IntegrationsMarketplaceGridAvailableRepository;
  public view: IntegrationsMarketplaceGridAvailableView;
  public viewConstructor: typeof IntegrationsMarketplaceGridAvailableView;
  public dataRepositoryConstructor: typeof IntegrationsMarketplaceGridAvailableRepository;

  constructor(component: IntegrationsMarketplaceGridAvailableWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: IntegrationsMarketplaceGridAvailableView,
      viewTemplate: templateIntegrationsMarketplaceGridAvailable,
      dataRepositoryConstructor: IntegrationsMarketplaceGridAvailableRepository,
    });
  }

  async getItems(request: CustomTemplateListRequest): Promise<GetItemsResponse> {
    return this.dataRepository.getItems(request);
  }

  async reloadGrid(filters: any) {
    this.view.dom.$cardboardAvailableGrid.filters = filters;
    await this.view.dom.$cardboardAvailableGrid.controller.render();
  }

}
